export default __webpack_public_path__ + "static/media/addFile.368b8c97.svg";